var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgKey(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M15.676 17.55c-.187 0-.34.15-.34.335v8.836l-2.734-2.688c-.35-.354-.33-.883.009-1.228l1.393-1.36-2.028-1.985c-.35-.336-.333-.874.009-1.227l1.875-1.854c-2.47-1.165-3.86-3.143-3.86-5.49 0-3.259 2.683-5.89 5.997-5.89C19.335 5 22 7.614 22 10.89a5.864 5.864 0 0 1-3.562 5.41v8.334c0 .291-.091.626-.35.856l-1.465 1.262c-.182.15-.395.237-.608.249v-9.115a.337.337 0 0 0-.339-.335zm-1.305-8.645c0 .892.727 1.607 1.626 1.607.905 0 1.631-.715 1.631-1.607s-.718-1.598-1.63-1.598c-.9 0-1.626.715-1.626 1.598z",
    fill: "#000",
    fillRule: "evenodd"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKey);
export default __webpack_public_path__ + "static/media/Key.3574c9f624d6207fe429bb322065abe0.svg";
export { ForwardRef as ReactComponent };